import { render } from "./Sanctions.vue?vue&type=template&id=76387d03&scoped=true"
import script from "./Sanctions.vue?vue&type=script&lang=js"
export * from "./Sanctions.vue?vue&type=script&lang=js"

import "./Sanctions.vue?vue&type=style&index=0&id=76387d03&scoped=true&lang=css"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76387d03"]])

export default __exports__